import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

export interface ICategory {
    id: number;
    name: string;
    description?: string;
  }
  export interface Subscription {
    id?: number,
    name: string,
    description: string,
    period: string,
    price?: number,
    limit?: number,
    freePeriods?: number,
    advised?: boolean,
    recommended?: boolean,
    actionText?: string,
    subscriptionType: string,
    priceIronia: number,
    priceProvider: number,
    riskLevel: number,
    providerId?: number,
    provider?: any,
    type?: string,
    limitPeriod?: number,
    isSelected?: boolean
}

export interface ISampleProfile {
    id?: number
    name: string,
    description?: string,
    summary?: string,
    image?: string,
    type?: number,
    elementsSigned?: any,
    subscriptionId?: number,
    relationId?: number,
    jsonFundsData?: any,
    createdAt?: string,
    updatedAt?: string,
    subscription: Subscription
}




export interface IRequestSampleProfileData {
    amount: number;
    reference: string;
    subject: string;
    urlOk?: string;
    urlError?: string;
    urlNotif?: string;
    customData: CustomDataDTO;
}

export interface CustomDataDTO {
    UserId: number;
    ClientData: ClientData;
    PaymentData: PaymentData;
    SampleProfileData: SampleProfileData;
}

export interface ClientData {
    email: string;
    firstName: string;
    lastName: string;
    secondLastName: string;
    phonePrefix: string;
    phone: string;
}

export interface PaymentData {
    // Rellena con los campos específicos de tu modelo .NET para PaymentData
}

export interface SampleProfileData {
    Name?: string;
    Description?: string;
    SubscriptionId?: number;
    JsonFundsData?: JsonFundsDataDto | string; // Puede venir deserializado o como string
}

export interface JsonFundsDataDto {
    Funds?: any[]; // O define mejor si sabes la forma
    Riesgo?: string;
    Rentabilidad?: number;
    Volatilidad?: number;
    FechaInicio?: string;
    PorfolioFinametrixId?: string;
    RiskProfile?: string;
}




class SampleProfile
{

    public getAllSampleProfiles = async (): Promise<ISampleProfile[]> => {
        return await fetch(`${proxyUrl}/sampleProfiles`)
            .then(async res => await res.json())
    }
    
    public getSampleProfilesByCategory = async (category?: number): Promise<ICategory > => {
        const url = `${proxyUrl}/sampleProfiles/category/${category}`;
        return await fetch(url)
            .then(async res => await res.json())
    }
    
    public getSampleProfile = async (sampleProfileId: string): Promise<ISampleProfile> => {
        return await fetch(`${proxyUrl}/sampleProfile/${sampleProfileId}`)
            .then(async res => await res.json())
    }
    
    public getTabs = async (): Promise<ICategory[]> => {
        return await fetch(`${proxyUrl}/sampleProfiles/categories`)
            .then(async res => await res.json())
    }

    public getSampleProfileBySavingPlanId = async (savingPlanId: number): Promise<number> =>
    {
        let url: string = `${proxyUrl}/sampleProfile/savingPlan/${savingPlanId}`;
        const req = await axios.get(url);
        return req.data;
    }

    public getSampleProfileForTheCover = async (portfolioId: string): Promise<any> =>
    {
        let url: string = `${proxyUrl}/sampleProfile/${portfolioId}/getForTheCover`;
        return await fetch(url).then(async res => await res.json())
    }


    public postSampleProfileNoPrice = async (requestClientData: IRequestSampleProfileData): Promise<any> =>
    {
        let url: string = `${proxyUrl}/sampleProfile/no-price?registered=true`;
        // let url: string = `https://ironiadevapimanagememt.azure-api.net/sampleProfile/no-price?registered=true`;
        const req = await axios.post(url, requestClientData);
        return req.data;
    }
}

const SampleProfileService = new SampleProfile();
export default SampleProfileService;